<template>

    <div>

        <login-aside />

        <main>
            <router-view />
        </main>
    </div>

</template>

<script>
import LoginAside from '../components/global/LoginAside';

export default
{
    name: 'Frontend',

    components:
    {
        LoginAside,
    }
}
</script>


// WEBPACK FOOTER //
// Frontend.vue?f1b54aec